var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get, isEmpty, sortBy } from "lodash";
import basket from "@irati/checkout/utils/basket";
import { BasketItemType } from "@irati/types";
import sagaService from "@irati/deals/services/perks-saga";
import willReachMaxAmount from "@irati/deals/helpers/product/willReachMaxAmount";
import CinemaSelection from "../../../components/ProductForms/CinemaSelection";
var CinemaProduct = /** @class */ (function (_super) {
    __extends(CinemaProduct, _super);
    function CinemaProduct(props) {
        var _this = _super.call(this, props) || this;
        _this.locations = function () {
            var products = _this.props.products;
            if (isEmpty(products)) {
                return [];
            }
            var cinemaLocations = [];
            products.forEach(function (prod) {
                var locations = get(prod, "data.cinemaMetadata.locations", []).map(function (loc) {
                    return {
                        location: loc,
                        uuid: prod.uuid,
                        outOfStock: false
                    };
                });
                cinemaLocations = cinemaLocations.concat(locations);
            });
            return sortBy(cinemaLocations, ["location", "uuid"]);
        };
        _this.handleSelectCinema = function (value) {
            basket.clear();
            var cinemaProds = _this.props.products.filter(function (prod) { return prod.data.cinemaMetadata.enabled; });
            var selectedProduct = cinemaProds.find(function (prod) { return (prod.data.cinemaMetadata.locations.find(function (loc) { return loc === value; })); });
            _this.setState({
                selectedProduct: selectedProduct,
                selectedLocation: value
            });
        };
        _this.handleUpdateQuantity = function (type) {
            var _a;
            var deal = _this.props.deal;
            var selectedProduct = _this.state.selectedProduct;
            if (selectedProduct) {
                var count = ((_a = basket.items.find(function (t) { return t.productId === selectedProduct.uuid; })) === null || _a === void 0 ? void 0 : _a.count) || 0;
                if (type === "+") {
                    count++;
                }
                else {
                    count--;
                }
                basket.setProduct(BasketItemType.Deal, deal.uuid, selectedProduct.uuid, { count: count });
                _this.setState({
                    willReachMax: willReachMaxAmount(deal, selectedProduct.uuid)
                });
            }
        };
        _this.state = {
            selectedLocation: null,
            willReachMax: false,
            cinemaLocations: _this.locations()
        };
        return _this;
    }
    CinemaProduct.prototype.componentDidMount = function () {
        var _this = this;
        sagaService.stockCount(this.props.deal.uuid).then(function (_a) {
            var stockTotals = _a.stockTotals;
            var cinemaLocations = _this.state.cinemaLocations;
            cinemaLocations.forEach(function (item) {
                var outOfStock = stockTotals[item.uuid] === 0;
                item.outOfStock = outOfStock;
            });
            _this.setState({ cinemaLocations: cinemaLocations });
        });
    };
    CinemaProduct.prototype.render = function () {
        return (React.createElement(CinemaSelection, { locations: this.state.cinemaLocations, selectedLocation: this.state.selectedLocation, selectedProduct: this.state.selectedProduct, handleChange: this.handleSelectCinema, handleClick: this.handleUpdateQuantity, deal: this.props.deal, products: this.props.products, willReachMax: this.state.willReachMax }));
    };
    CinemaProduct.propTypes = {
        products: PropTypes.array.isRequired,
        deal: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired
    };
    return CinemaProduct;
}(Component));
export default CinemaProduct;
